module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Free"
  }, [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent,
      "activeTo": "Home"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "free_content"
  }, [_c('h1', {
    staticClass: "Free_title font_mid"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('user_center_order_order_details')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "free_productClass"
  }, [_c('div', {
    staticClass: "pcShow"
  }, [_c('div', {
    staticClass: "free_sm_title"
  }, [_c('div', {
    staticClass: "free_img font_tip"
  }), _vm._v(" "), _c('div', {
    staticClass: "free_name font_tip"
  }, [_vm._v(_vm._s(_vm.$t('user_center_order_product')))]), _vm._v(" "), _c('div', {
    staticClass: "free_price font_tip"
  }, [_vm._v(_vm._s(_vm.$t('user_center_order_price')))]), _vm._v(" "), _c('div', {
    staticClass: "free_num font_tip"
  }, [_vm._v(_vm._s(_vm.$t('user_center_order_Quantity')))]), _vm._v(" "), _c('div', {
    staticClass: "free_total font_tip"
  }, [_vm._v(_vm._s(_vm.$t('total')))])]), _vm._v(" "), _c('div', {
    staticClass: "free_product"
  }, [_c('div', {
    staticClass: "free_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.mogos.goods_img,
      "width": "120"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "free_name"
  }, [_c('p', {
    staticClass: "font_small"
  }, [_vm._v(_vm._s(_vm.mogos.goods_name))]), _vm._v(" "), _c('p', {
    staticClass: "font_small",
    staticStyle: {
      "padding": "0 10px 0 0"
    }
  }, [_vm._v(_vm._s(_vm.mogos.goods_remark))])]), _vm._v(" "), _c('div', {
    staticClass: "free_price font_mid"
  }, [_vm._v(_vm._s(_vm.mogos.goods_unit) + _vm._s(_vm.mogos.market_price))]), _vm._v(" "), _c('div', {
    staticClass: "free_num font_mid"
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "free_total font_mid"
  }, [_vm._v("USD $" + _vm._s(_vm.mogos.goods_price))])])]), _vm._v(" "), _c('div', {
    staticClass: "mbShow"
  }, [_c('div', {
    staticClass: "free_product"
  }, [_c('div', {
    staticClass: "free_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.mogos.goods_img,
      "width": "100"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "free_name"
  }, [_c('p', {
    staticClass: "font_small"
  }, [_vm._v(_vm._s(_vm.mogos.goods_name))]), _vm._v(" "), _c('p', {
    staticClass: "font_small"
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "line-through",
      "color": "red"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#1f2d3d"
    }
  }, [_vm._v(_vm._s(_vm.mogos.goods_unit) + _vm._s(_vm.mogos.market_price))])]), _vm._v("X 1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "free_productAdvantage"
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h1', {
    staticClass: "Free_title font_mid"
  }, [_vm._v(_vm._s(_vm.$t('home_text_product')))])]), _vm._v(" "), _vm._l((_vm.Advantage_list), function(list, index) {
    return _c('i-col', {
      key: index,
      staticClass: "Advantage_wrap",
      attrs: {
        "lg": 12,
        "md": 12,
        "sm": 24,
        "xs": 24
      }
    }, [_c('div', {
      staticClass: "Advantage_img font_small"
    }, [_c('img', {
      attrs: {
        "src": list.img,
        "width": "50"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "Advantage_other"
    }, [_c('p', {
      staticClass: "font_small"
    }, [_vm._v(_vm._s(list.title))]), _vm._v(" "), _c('p', {
      staticClass: "font_small"
    }, [_vm._v(_vm._s(list.content))])])])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "free_productSelect"
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "free_productSelect_title"
  }, [_c('h1', {
    staticClass: "font_mid",
    staticStyle: {
      "margin": "30px 0"
    }
  }, [_vm._v(_vm._s(_vm.$t('free_select_title')))])])]), _vm._v(" "), _vm._l((_vm.select), function(block, index) {
    return _c('i-col', {
      key: index,
      attrs: {
        "lg": 8,
        "md": 8,
        "sm": 24,
        "xs": 24
      }
    }, [_c('div', {
      staticClass: "Select_block",
      class: {
        active: index == _vm.num
      },
      on: {
        "click": function($event) {
          _vm.selectThis(index, block.goods_id)
        }
      }
    }, [_c('h1', {
      class: {
        active_font: index == _vm.num
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "35px"
      }
    }, [_vm._v("$")]), _vm._v(_vm._s(block.goods_name))]), _vm._v(" "), _c('p', {
      staticClass: "font_small"
    }, [_vm._v(_vm._s(block.innclude_content))]), _vm._v(" "), _c('p', {
      staticClass: "font_small"
    }, [_vm._v(_vm._s(block.goods_remark))]), _vm._v(" "), (block.goods_name == 10) ? _c('p', {
      staticClass: "font_small",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(_vm.$t('free_text')))]) : _vm._e(), _vm._v(" "), (block.goods_name == 20) ? _c('p', {
      staticClass: "font_small",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(_vm.$t('free_text2')))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "select_btn"
    }, [_c('button', {
      on: {
        "click": function($event) {
          _vm.Collocation = true
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('free_topup')))])])])])
  })], 2)], 1)])]), _vm._v(" "), _c('modal', {
    staticClass: "Collocation",
    model: {
      value: (_vm.Collocation),
      callback: function($$v) {
        _vm.Collocation = $$v
      },
      expression: "Collocation"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "Collocation_title"
  }, [_c('h2', {
    staticClass: "font_mid"
  }, [_vm._v(_vm._s(_vm.$t('free_select_page')))])]), _vm._v(" "), _c('Row', {
    staticClass: "Collocation_group"
  }, _vm._l((_vm.FreeColl), function(block, index) {
    return _c('i-col', {
      key: index,
      staticClass: "Collocation_main",
      attrs: {
        "lg": 8,
        "md": 8,
        "sm": 12,
        "xs": 12
      }
    }, [_c('div', {
      staticClass: "Collocation_wrap"
    }, [_c('span', [_c('div', {
      staticClass: "detail-btn",
      on: {
        "click": function($event) {
          _vm.chooseOrder($event, block.goods_id)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "Collocation_block"
    }, [_c('div', {
      staticClass: "Collocation_blockImg"
    }, [_c('img', {
      attrs: {
        "src": block.goods_img
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "Collocation_block_part1"
    }, [_c('p', {
      staticClass: "font_mid"
    }, [_vm._v(_vm._s(block.goods_name))]), _vm._v(" "), _c('p', {
      staticClass: "font_small",
      domProps: {
        "innerHTML": _vm._s(block.goods_remark)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "Collocation_block_part2",
      on: {
        "click": function($event) {
          _vm.detail(block.goods_alias, block.goods_id)
        }
      }
    }, [_c('p', {
      staticClass: "font_mid",
      staticStyle: {
        "color": "#0084ff"
      }
    }, [_vm._v("$" + _vm._s(block.goods_price))]), _vm._v(" "), _c('a', {
      staticClass: "font_small"
    }, [_vm._v("\n                                    " + _vm._s(_vm.$t('learn_details')) + " "), _c('Icon', {
      attrs: {
        "type": "arrow-right-c"
      }
    })], 1)])])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "Collocation_footer"
  }, [_c('div', {
    staticClass: "Collocation_pay"
  }, [_c('button', {
    on: {
      "click": _vm.check
    }
  }, [_vm._v(_vm._s(_vm.$t('free_btn1')))])]), _vm._v(" "), _c('a', {
    staticClass: "font_small",
    on: {
      "click": _vm.jump
    }
  }, [_vm._v(_vm._s(_vm.$t('free_btn2')))])])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })]), _vm._v(" "), _c('BackTop', [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/top.png")
    }
  }), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(_vm.$t('top_btn')))])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://ifree.ly/support",
      "target": "_blank"
    }
  }, [_c('BackTop', {
    attrs: {
      "height": 100,
      "bottom": 110
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/service.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Service_btn')))])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64b2b6f4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Free/Free.vue
// module id = 821
// module chunks = 0